import { DashboardMetricCard } from '../components/DashboardMetricCard';
import { formatDashboardPreviousPeriod } from '../format';
import { dashboardTimeline, DashboardWidgetType } from '../model';
import type { DashboardWidgetRendererProps } from './widgetRenderers.types';

export function MetricRenderer({ widget, query, range }: DashboardWidgetRendererProps) {
  if (widget.type !== DashboardWidgetType.Metric) return null;
  const timeline = query?.data ? dashboardTimeline(query.data, range) : [];
  return (
    <DashboardMetricCard
      metric={widget.metric}
      total={query?.data?.total}
      previous={query?.data?.totalPrevious}
      comparisonPeriod={formatDashboardPreviousPeriod(range, query?.data?.previousPeriodEnd)}
      timeline={timeline}
      loading={Boolean(query?.isLoading)}
      error={Boolean(query?.isError)}
      actions={widget.actions}
    />
  );
}
